function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m277.640625 264.023438c-7.125-23.65625-28.914063-39.847657-53.621094-39.847657s-46.492187 16.191407-53.621093 39.847657zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m406.871094 280.023438h-365.742188c-8.039062-.023438-15.554687 3.992187-20 10.6875l-14.175781 21.3125h434.09375l-14.207031-21.3125c-4.441406-6.683594-11.941406-10.699219-19.96875-10.6875zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m216 120.023438h16v104h-16zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m56 72.023438h128v16h-128zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m265.601562 328.023438h-83.203124c-4.234376 7.285156-6.445313 15.574218-6.398438 24 0 26.511718 21.492188 48 48 48s48-21.488282 48-48c.046875-8.425782-2.164062-16.714844-6.398438-24zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m256 80.023438c0 17.671874-14.328125 32-32 32s-32-14.328126-32-32c0-17.671876 14.328125-32 32-32s32 14.328124 32 32zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m40 .0234375h-40v176.0000005h40c4.417969 0 8-3.582032 8-8v-160c0-4.417969-3.582031-8.0000005-8-8.0000005zm0 0"
});

function Svg121(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "441pt",
    viewBox: "0 -20 441.048 441",
    width: "441pt",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg121);
export default __webpack_public_path__ + "static/media/1_21.19e1cef7.svg";
export { ForwardRef as ReactComponent };